/**
 * Ecoma Story
 * Premium Interactions
 */

(() => {

  function initEcomaStory(section = document) {

    const stories = section.querySelectorAll(".ecoma-story");

    stories.forEach((story) => {

      /* --------------------------
         Scroll Reveal
      --------------------------- */

      const revealItems = story.querySelectorAll(
        ".story-label, .story-heading, .story-descriptionn, .story-question, .story-footer, .story-visual"
      );

      if ("IntersectionObserver" in window) {

        const observer = new IntersectionObserver(

          (entries, obs) => {

            entries.forEach((entry) => {

              if (!entry.isIntersecting) return;

              entry.target.classList.add("reveal");

              obs.unobserve(entry.target);

            });

          },

          {
            threshold: 0.15,
            rootMargin: "0px 0px -80px 0px"
          }

        );

        revealItems.forEach((item, index) => {

          item.style.transitionDelay = `${index * 100}ms`;

          observer.observe(item);

        });

      } else {

        revealItems.forEach((item) => item.classList.add("reveal"));

      }

     

      

      /* --------------------------
         Button Hover Ripple
      --------------------------- */

      const button = story.querySelector(".story-btn");

      if (button) {

        button.addEventListener("mousemove", (e) => {

          const rect = button.getBoundingClientRect();

          button.style.setProperty(
            "--x",
            `${e.clientX - rect.left}px`
          );

          button.style.setProperty(
            "--y",
            `${e.clientY - rect.top}px`
          );

        });

      }

    });

  }

  document.addEventListener("DOMContentLoaded", () => {

    initEcomaStory();

  });

  document.addEventListener("shopify:section:load", (e) => {

    initEcomaStory(e.target);

  });

})();